import { ReactComponent as DropdownIcon } from "components/Icons/chevron-up.svg";
import { ReactComponent as EditIcon } from "components/Icons/edit-03.svg";
import { useState } from "react";
import { useStyles } from "./styles";

interface Props {
  title: string;
  children: React.ReactNode;
  onClick: () => void;
  noPadding?: boolean;
}

export const SectionWrapper = ({
  title,
  children,
  onClick,
  noPadding,
}: Props) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const classes = useStyles({ isExpanded, noPadding });

  return (
    <>
      <div>
        <div className={classes.header}>
          <span>{title}</span>
          <div className={classes.icons}>
            <DropdownIcon
              className={classes.dropdownIcon}
              onClick={() => setIsExpanded(!isExpanded)}
            />
            <EditIcon onClick={onClick} />
          </div>
        </div>
        {isExpanded && <div className={classes.content}>{children}</div>}
      </div>
    </>
  );
};
